import * as Yup from "yup";

const WorkClassificationSchema = Yup.object().shape({
  work_classification_name: Yup.string().required("Name is required"),
  company_id: Yup.string().required("Company is required"),
});

export default WorkClassificationSchema;
